import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ContragentWithContactDto } from "../../../models/contragent/contragent-with-contact-dto";
import { ContragentsService } from "../../../../categories/contragents/contragents.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import { NgModel } from "@angular/forms";
import { AddressSuggestion } from "../../../models/dadata-address/address-suggestion";
import { DaDataAddressComponent } from "../../dadata-address/dadata-address.component";
import { Subscription } from "rxjs";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { LookupService } from "../../../services/lookup.service";
import { DropdownListCountryPhoneMasksComponent } from "../../dropdownlist-country-phone-masks/dropdownlist-country-phone-masks.component";
import { DialogService } from "@progress/kendo-angular-dialog";
import { AddressClarificationComponent } from "../../adresses/address-clarification/address-clarification.component";

@Component({
	selector: 'create-contragent',
	templateUrl: './create-contragent.component.html',
	styleUrls: [
		'./create-contragent.component.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class CreateContragentComponent implements OnInit, AfterViewInit {

	@ViewChild("inn") innModel: NgModel;
	@ViewChild("contactPhone") contactPhoneModel: NgModel;
	@ViewChild("dadataAddressControl") dadataAddressControl: DaDataAddressComponent;
	@ViewChild('countryPhoneMasksComponent') countryPhoneMasksComponent: DropdownListCountryPhoneMasksComponent;

	@Input() contragentEntity: ContragentWithContactDto = null;
	@Input() isEditing: boolean = false;
	@Input() defaultContactPhone: string;

	/** Предзаполнение при создании клиента (например, из лида). */
	@Input() initialNewContragentPrefill: Partial<ContragentWithContactDto> = null;

	/** Ид лида-источника при создании клиента из заявки с leadId. */
	@Input() sourceLeadId: number = null;

	@Output() onContinueEvent: EventEmitter<ContragentWithContactDto> = new EventEmitter<ContragentWithContactDto>();
	@Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();

	countryId: number = 1;

	innSearchPauseTime = 200;
	innSearchDelay: NodeJS.Timer;
	innSearchSubsription: Subscription;

	public cellPhoneMask: string = "+7 (000) 000-00-00";
	public rules: { [key: string]: RegExp } = {
		'0': /\d/
	};

	public listData: Array<string> = ["Visa", "Mastercard", "Paypal"];

	entity: ContragentWithContactDto;

	paymentTypes: KeyValueObject[] = [];

	loading: boolean = false;
	isInnValid: boolean = null;

	constructor(
		public contragentsService: ContragentsService,
		public notificationService: NotificationService,
		private lookupService: LookupService,
		private dialogService: DialogService
	) { }

	ngOnInit(): void {

		this.lookupService.getData('payment-types', null).subscribe(resp => {
			this.paymentTypes = resp;
		});

		if (this.contragentEntity == null) {
			this.entity = new ContragentWithContactDto();
			this.entity.contactPhone = this.defaultContactPhone;
			if (this.initialNewContragentPrefill) {
				const pre = this.initialNewContragentPrefill;
				Object.assign(this.entity, pre);
				if (pre.contactPhone != null && String(pre.contactPhone).trim() !== '') {
					this.entity.contactPhone = pre.contactPhone;
				} else if (this.defaultContactPhone) {
					this.entity.contactPhone = this.defaultContactPhone;
				}
			}
			if (this.sourceLeadId != null) {
				this.entity.sourceLeadId = this.sourceLeadId;
			}
			this.refreshMask();
		}
		else {
			this.entity = { ...this.contragentEntity };
			this.refreshMask();
			//this.isInnValid = this.entity.inn != null;
		}
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			if (this.dadataAddressControl && this.entity && this.entity.address) {
				this.dadataAddressControl.initValue(this.entity.address);
			}
		});
	}

	showAddressClarification(isEditing: boolean) {
		const dialogRef = this.dialogService.open({
			content: AddressClarificationComponent,
			width: '80%',
			height: '820px',
			minWidth: '800px'
		});
		const addressClarification = <AddressClarificationComponent>dialogRef.content.instance;

		addressClarification.height = 460;
		addressClarification.address = this.entity.address;
		addressClarification.onCancelEvent.subscribe(() => { 
			this.loading = false;
			dialogRef.close();
		 });
		addressClarification.onContinueEvent.subscribe(yandexModel => {

			this.entity.yandexModel = yandexModel;

			if (isEditing) {
				this.contragentsService.updateContragentWithContact(this.entity).subscribe((resp) => {
					this.entity.yandexModel = null;
					this.refreshAndContinue(this.entity.id, resp.isSuccessful, resp.errorDescription);
					dialogRef.close();
				}, () => {
					this.loading = false;
					this.entity.yandexModel = null;
				});
			} else {
				this.contragentsService.createContragentWithContact(this.entity).subscribe((resp) => {
					this.refreshAndContinue(resp.data.id, resp.isSuccessful, resp.errorDescription, this.entity.yandexModel);
					dialogRef.close();
				}, () => {
					this.loading = false;
					this.entity.yandexModel = null;
				});
			}
		});
	}

	save() {
		this.loading = true;
		if (this.isEditing) {
			this.contragentsService.updateContragentWithContact(this.entity).subscribe((resp) => {
				if (resp.isSuccessful) {
					if (!resp.data.addressOk) {
						this.showAddressClarification(this.isEditing);
						return;
					}
				}

				this.refreshAndContinue(this.entity.id, resp.isSuccessful, resp.errorDescription);
			}, () => this.loading = false);
		}
		else {
			this.contragentsService.createContragentWithContact(this.entity).subscribe((resp) => {
				if (resp.isSuccessful) {
					if (!resp.data.addressOk) {
						this.showAddressClarification(this.isEditing);
						return;
					}
				}

				this.refreshAndContinue(resp.data.id, resp.isSuccessful, resp.errorDescription);
			}, () => this.loading = false);
		}
	}

	refreshAndContinue(id: number, isSuccessful: boolean, errorMessage: string = null, yandexModel: any = null) {
		if (isSuccessful) {
			this.contragentsService.getContragentWithContact(id).subscribe((getResp) => {
				this.entity = getResp;
				this.entity.yandexModel = yandexModel;
				this.onContinueEvent.emit(this.entity);
			}, () => this.loading = false);
		}
		else {
			this.loading = false;
		}
	}

	setMask(mask: string) {
		this.cellPhoneMask = mask;
		this.entity.contactPhone = '';
	}

	refreshMask() {
		this.cellPhoneMask = this.countryPhoneMasksComponent.getAndSetPhoneMask(this.entity.contactPhone);
	}

	onAddressChange(value: AddressSuggestion) {
		this.entity.address = value.address;
	}

	cancel() {
		this.onCancelEvent.emit();
	}

	changeInn(inn: string) {
		// if (inn && inn.length >= 10) {
		// 	this.seacrhDataByInn(inn);
		// }
	}

	onblurInn(elem: any) {
		let inn = elem.srcElement.value;

		if (inn && inn.length >= 10) {
			this.seacrhDataByInn(inn);
		}
	}

	onEnterInn(elem: any) {
		let inn = elem.srcElement.value;

		if (inn && inn.length >= 10) {
			this.seacrhDataByInn(inn);
		}
	}

	seacrhDataByInn(inn: string) {
		this.loading = true;
		if (this.innSearchDelay) {
			clearTimeout(this.innSearchDelay);
		}

		if (inn == null || inn.trim() == '') {
			this.isInnValid = true;
			return;
		}

		this.innSearchDelay = setTimeout(() => {
			if (this.innSearchSubsription) {
				this.innSearchSubsription.unsubscribe();
			}

			this.innSearchSubsription = this.contragentsService.getContragentEgrData(inn)
				.subscribe((response) => {
					if (response.founded) {
						this.isInnValid = !!response.fullName && !!response.fullAddress;

						this.entity.name = response.fullName;
						this.entity.legalName = response.legalName;
						this.dadataAddressControl.initValue(response.fullAddress);
						this.entity.address = response.fullAddress;
						this.entity.kpp = response.kpp;
						this.entity.inn = response.inn;
						this.entity.ogrn = response.ogrn;
						this.entity.ceoName = response.ceoName;
						this.entity.shortName = response.shortName;
						this.entity.accountingInfo = JSON.stringify({
							kpp: response.kpp,
							inn: response.inn,
							ogrn: response.ogrn,
							ceo: response.ceoName
						});
					}
					else if (response.message) {
						this.isInnValid = false;
						this.notificationService.info({
							title: response.message,
							notificationType: NotificationType.Toast
						});
					}
					else {
						this.isInnValid = false;
					}
					this.loading = false;
				},
					() => {
						this.loading = false;
						this.isInnValid = false;
					});
		}, this.innSearchPauseTime);
	}

	get canCreate(): boolean {
		return this.entity != null && !this.contactPhoneModel.invalid && !this.innModel.invalid && (this.isInnValid === true || !!!this.entity.inn);
	}
}